/**
 * @generated SignedSource<<0cf50a1438890541610bc1569f3fc798>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanionModeThroughEventGuidQuery$variables = {
  eventGuid: string;
};
export type CompanionModeThroughEventGuidQuery$data = {
  readonly event: {
    readonly id: string;
    readonly note: {
      readonly id: string;
    } | null;
  } | null;
  readonly viewer: {
    readonly uxSimplificationEnabled: boolean;
  };
};
export type CompanionModeThroughEventGuidQuery = {
  response: CompanionModeThroughEventGuidQuery$data;
  variables: CompanionModeThroughEventGuidQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventGuid"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uxSimplificationEnabled",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": "event",
  "args": [
    {
      "kind": "Variable",
      "name": "guid",
      "variableName": "eventGuid"
    }
  ],
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "eventByGuid",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "ifNotExists",
          "value": "CREATE"
        }
      ],
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": "note(ifNotExists:\"CREATE\")"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanionModeThroughEventGuidQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanionModeThroughEventGuidQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "8bc6ef68923ca525f955239e239c000b",
    "id": null,
    "metadata": {},
    "name": "CompanionModeThroughEventGuidQuery",
    "operationKind": "query",
    "text": "query CompanionModeThroughEventGuidQuery(\n  $eventGuid: String!\n) {\n  viewer {\n    uxSimplificationEnabled\n    id\n  }\n  event: eventByGuid(guid: $eventGuid) {\n    id\n    note(ifNotExists: CREATE) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "90c81aecf74c5fd184039030c10835a9";

export default node;
